import { CSSProperties } from 'react';

export const checkIsSmallVideo = (_containerStyle: CSSProperties): boolean => {
  return false;

  // TODO @kashish -- Verify this with product team, since this affects animation menu expectations
  // const width = containerStyle.width;

  // if (typeof width === 'string' && width.endsWith('%')) {
  //   return parseFloat(width) < 20;
  // }

  // return false;
};
